import type { Color } from '@anov/3d-core'

export { FinirMaterial } from './FinirMaterial'

export interface FinirMaterialInterface {

  /**
   * 颜色
   */
  rimColor: Color

  /**
   * 强度
   */
  rimPower: number
}
